import * as React from 'react';

function Plus(props) {
	return (
		<svg
			aria-label={`plus sign icon`}
			width={17}
			height={17}
			viewBox={`0 0 17 17`}
			fill={`none`}
			xmlns={`http://www.w3.org/2000/svg`}
			{...props}
		>
			<title>plus sign icon</title>
			<path
				d={`M0 8.5H17`}
				stroke={`currentColor`}
				strokeWidth={1.6}
			/>
			<path
				d={`M8.5 0L8.5 17`}
				stroke={`currentColor`}
				strokeWidth={1.6}
			/>
		</svg>
	);
}

export default Plus;
